;(() => {
  const productTemplate = document
    .querySelector('html')
    .classList.contains('template-product')

  if (productTemplate) {
    const productFullscreenImages = document.querySelector(
      '.product-fullscreen-images'
    )
    const htmlElement = document.documentElement

    //open fullscreen images modal and scroll to relevant image
    document
      .querySelectorAll(
        '.swiper-product .swiper-slide[data-media-type="image"], .product-images-grid figure[data-media-type="image"]'
      )
      .forEach((slide) => {
        slide.addEventListener('click', () => {
          const mediaId = slide.getAttribute('data-media-id')
          productFullscreenImages.classList.add('active')
          const relevantImage = productFullscreenImages.querySelector(
            `#media-id-${mediaId}`
          )
          relevantImage.scrollIntoView()
          htmlElement.classList.add('fullscreen-product-images-open')
        })
      })

    //click anywhere to close product fullscreen images
    productFullscreenImages.addEventListener('click', () => {
      productFullscreenImages.classList.remove('active')
      htmlElement.classList.remove('fullscreen-product-images-open')
    })

    document
      .querySelector('button[data-scroll-to="product-reviews"]')
      ?.addEventListener('click', () => {
        document
          .querySelector('.yotpo-widget-instance')
          ?.scrollIntoView({ behavior: 'smooth' })
      })

    const questionCountEl = document.querySelector('.question-count')
    const answerCountEl = document.querySelector('.answer-count')
    if (questionCountEl || answerCountEl) {
      const appKey = 'LfxGUzKOHzFAf5wuzqy3yMTrjFxr0grLUQHam4k9'
      const productId = document.documentElement.dataset.productId
      fetch(
        `https://api.yotpo.com/products/${appKey}/${productId}/qna_bottomline`
      )
        .then((res) => res.json())
        .then((data) => {
          const { total_questions, total_answers } = data?.response ?? {}
          if (total_questions || total_answers) {
            document.querySelector('.product-questions-and-answers').style.display = ''
          }
          if (total_questions) {
            questionCountEl.textContent = total_questions
            document.querySelector('.question-label').textContent =
              total_questions === 1 ? 'Question' : 'Questions'
          }
          if (total_answers) {
            answerCountEl.textContent = total_answers
            document.querySelector('.answer-label').textContent =
              total_answers === 1 ? 'Answer' : 'Answers'
          }
        })
    }
  }
})()
